import script from "./TransferRequestForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferRequestForm.vue?vue&type=script&setup=true&lang=js"

import "./TransferRequestForm.vue?vue&type=style&index=0&id=df768e2a&lang=scss"

const __exports__ = script;

export default __exports__